import {blockExtensions} from '../../conf/extensions'

export {blockExtensions}


// WEBPACK FOOTER //
// ./src/fm/conf/extensions.js